var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.redirectTo,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-bold text-lg" }, [
                        _vm._v("Documents"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "UploadDocument",
          fn: function () {
            return [
              _c("UploadDocument", {
                attrs: {
                  companyId: _vm.companyId,
                  currentUserId: _vm.currentUserId,
                  currentUser: _vm.currentUser,
                },
                on: { refetchDocuments: _vm.refetchDocuments },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "flex mt-20" }, [
        _c(
          "div",
          { staticClass: "flex-auto inline-flex" },
          [
            _c(
              "RouterLink",
              { attrs: { to: { name: _vm.redirectTo } } },
              [
                _c("CardItemScaffold", {
                  staticClass: "mb-2",
                  attrs: { itemNumber: _vm.allDocumentsTotal, flexRow: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("DocumentIcon", {
                            staticClass:
                              "h-5 w-5 fill-current text-primary-500",
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("p", { staticClass: "mt-8 pl-2 mr-8/12 text-sm" }, [
              _vm._v("All"),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-auto inline-flex" },
          [
            _c(
              "RouterLink",
              { attrs: { to: { name: _vm.redirectToProject } } },
              [
                _c("CardItemScaffold", {
                  staticClass: "mb-2",
                  attrs: { itemNumber: _vm.projectDocumentsTotal, flexRow: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("DocumentIcon", {
                            staticClass:
                              "h-5 w-5 fill-current text-primary-500",
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("p", { staticClass: "mt-8 pl-2 mr-8/12 text-sm" }, [
              _vm._v("Projects"),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-auto inline-flex" },
          [
            _c(
              "RouterLink",
              { attrs: { to: { name: _vm.redirectToContractor } } },
              [
                _c("CardItemScaffold", {
                  attrs: { itemNumber: _vm.contractorDocumentsTotal },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("DocumentIcon", {
                            staticClass:
                              "h-5 w-5 fill-current text-primary-500",
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("p", { staticClass: "mt-8 pl-2 mr-8/12 text-sm" }, [
              _vm._v("Contractors"),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }